export default __webpack_public_path__ + "static/media/black75Discount@3x.df61fc91.png";